import { render } from "./CreateCurrencyModal.vue?vue&type=template&id=6586f7ea"
import script from "./CreateCurrencyModal.vue?vue&type=script&lang=js"
export * from "./CreateCurrencyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__